import styled from "styled-components";
import { theme } from '../../theme'

export const AccountSectionContainer = styled.div`
    margin-top: 2.7rem;
`

export const AccountActionsCardWrapper = styled.div`
    background-color: ${theme.colors.mainWhite};
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.0293252);
    border-radius: 1.1rem;
`